module.exports = __webpack_public_path__ + "97d1d6bc5af1574cc7628e7e03787e47.MP3";